import styled from 'styled-components';

export const Wrapper = styled.div`
    background-color: #fff;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    padding: 10px 14px;
`;

export const Avatar = styled.div``;
export const Content = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    gap: 4px;
    min-width: 0;
    min-height: 0;
`;

export const ContentHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
`;
export const ContentHeaderLeft = styled.div`
    color: rgba(0, 0, 0, 0.25);
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
`;
export const ContentHeaderRight = styled.div``;

export const ContentTitle = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
`;
export const ContentTitleLeft = styled.div`
    flex: 60% 0 0;
    font-weight: bold;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
`;
export const ContentTitleRight = styled.div``;

export const ContentMain = styled.div`
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const ContentFooter = styled.div`
    text-align: right;
    color: rgba(0, 0, 0, 0.25);
`;
